import { GridCellEditWebComponent } from './component/GridCellEditWebComponent';
import { WEB_COMPONENT_GRID_CELL_EDIT } from '../../../webcomponents.constants';

export { GridCellEditWebComponent };

if (!window.customElements.get(WEB_COMPONENT_GRID_CELL_EDIT)) {
  window.customElements.define(WEB_COMPONENT_GRID_CELL_EDIT, GridCellEditWebComponent);
}
